module.exports = __webpack_public_path__ + "static/media/f-pop-up-1.2aa8f019.png";